import React, { useState } from 'react';
import { StyledKeyLegend, StyledKeyLegendMobileCloseButton, StyledMobileLegendButton } from '../Styled';
import assetLocationIcon from '../icons/asset-location-icon.svg';
import personIcon from '../icons/person-icon.svg';
import deviceIcon from '../icons/device-icon.svg';
import mobileLegendIcon from '../icons/mobile-legend.svg';
import staleIcon from '../icons/stale-asset.svg';
import useDevice from 'hooks/useDevice';

export default function KeyLegend() {

  const [mobileLegendOpen, setMobileLegendOpen] = useState(false);
  const { isMobileDevice, isShortViewportDevice } = useDevice();

  const items = (
    <ul>
      <>
        <li>
          <img src={staleIcon} alt="old Estimate" />
          <span>Old Estimate</span>
        </li>
        <li>
          <img src={assetLocationIcon} alt="Asset Location" />
          <span>Asset Location</span>
        </li>
      </>

      <div className="hr" />

      <li>
        <img src={personIcon} alt="Person" />
        <span>Phone-user</span>
      </li>
      <li>
        <img src={deviceIcon} alt="Device" />
        <span>Phone-device</span>
      </li>
    </ul>
  )

  if (isMobileDevice || isShortViewportDevice) {
    return mobileLegendOpen
      ? (
        <StyledKeyLegend data-test-id="legend">
          <StyledKeyLegendMobileCloseButton onClick={() => setMobileLegendOpen(false)} />
          {items}
        </StyledKeyLegend>)
      : (
        <StyledMobileLegendButton data-test-id="mobile-legend-button" onClick={() => setMobileLegendOpen(!mobileLegendOpen)}>
          <img src={mobileLegendIcon} alt="mobile legend" />
        </StyledMobileLegendButton>
      )
  }

  return (
    <StyledKeyLegend data-test-id="legend">
      {items}
    </StyledKeyLegend>
  );
}
